import React, { useRef } from "react";

const SearchBar = ({
    id,
    value = "",
    onChange,
    placeholder = "Search…",
    className = "",
    autoFocus = false,
}) => {
    const inputRef = useRef(null);

    const handleClear = () => {
        onChange({ target: { value: "" } });
        if (inputRef.current) inputRef.current.focus();
    };

    return (
        <div className={`relative flex items-center ${className}`}>
            <span className="pointer-events-none absolute left-4 text-ink-400" aria-hidden="true">
                <i className="fas fa-search text-sm" />
            </span>
            <input
                ref={inputRef}
                id={id}
                type="text"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoFocus={autoFocus}
                style={{ paddingLeft: "2.75rem" }}
                className="w-full rounded-xl border border-ink-200 bg-white py-2.5 pr-8 text-sm text-ink-900 placeholder:text-ink-400 transition-colors hover:border-ink-300 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-200"
            />
            {value && (
                <button
                    type="button"
                    onClick={handleClear}
                    aria-label="Clear search"
                    className="absolute right-3 flex h-4 w-4 items-center justify-center rounded-full bg-ink-200 text-ink-500 transition-colors hover:bg-ink-300 hover:text-ink-700"
                >
                    <i className="fas fa-times" style={{ fontSize: "0.6rem" }} aria-hidden="true" />
                </button>
            )}
        </div>
    );
};

export default SearchBar;
